'use client'
import { hermesLogger } from '@core/observability'
import {
  hubSelected,
  setHubSelectedApollo,
} from '@data/reactive-variables/hubs'
import { safeLocalStorage } from '@utils/utilities'

import {
  IHub,
  IHubList,
} from '../hooks/use-get-hubs-list/use-get-hubs-list.hook.types'

const HUBS_LIST = 'hubsList'
const HUB_SELECTED = 'hubsSelected'

export function hubHandler() {
  function clearHubs() {
    safeLocalStorage.removeItem(HUBS_LIST)
    safeLocalStorage.removeItem(HUB_SELECTED)
    setHubSelectedApollo(null)
  }

  function setHubsList(hubList: IHubList) {
    safeLocalStorage.setItem(HUBS_LIST, JSON.stringify(hubList))
  }

  function getHubsList(): IHubList | undefined {
    const hubsStringify = safeLocalStorage.getItem(HUBS_LIST)
    const hubsList: IHubList | undefined = hubsStringify
      ? JSON.parse(hubsStringify)
      : undefined

    return hubsList
  }

  function setHubSelected(id: string) {
    const hubsList = getHubsList()

    if (hubsList) {
      const hubSelected: IHub =
        hubsList.find((hub) => id === hub.id) || hubsList[0]

      safeLocalStorage.setItem(HUB_SELECTED, JSON.stringify(hubSelected))
      setHubSelectedApollo(hubSelected)
    } else {
      hermesLogger.error(
        `[hubHandle] Error in get hubsList in the storage to the user and can not set hubId ${id}`
      )
    }
  }

  function getHubSelected(): IHub | undefined {
    const hubsStringify = safeLocalStorage.getItem(HUB_SELECTED)
    const hubSelected: IHub | undefined = hubsStringify
      ? JSON.parse(hubsStringify)
      : undefined

    return hubSelected
  }

  function getHubIdSelected(): string {
    return getHubSelected()?.id ?? ''
  }

  function setDefaultHub() {
    const hasHubSelected = getHubSelected()

    if (!hasHubSelected) {
      const hubsList = getHubsList()

      if (hubsList) {
        setHubSelected(hubsList[0].id)
      } else {
        hermesLogger.error(
          `[hubHandle] Error in get hubsList in the storage to the user and can not set Default hubId`
        )
      }
    } else {
      setHubSelectedApollo(hasHubSelected)
    }
  }

  function getHubSelectedFromApollo(): IHub | null {
    const result = hubSelected()

    if (!result) {
      const hub = hubHandler().getHubSelected()

      if (hub) {
        return hub
      }

      return null
    }

    return result
  }

  return {
    clearHubs,
    setHubsList,
    getHubsList,
    setHubSelected,
    getHubSelected,
    getHubIdSelected,
    setDefaultHub,
    getHubSelectedFromApollo,
  }
}
